/* eslint-disable @next/next/no-img-element */
import parse from "react-html-parser"
import { observer } from "mobx-react"
import { useStore } from "@features/common"

import WhatWeAreIntoFirstItemImage from "./what-we-are-into-first-item.png"
import WhatWeAreIntoSecondItemImage from "./what-we-are-into-second-item.png"
import WhatWeAreIntoThirdItemImage from "./what-we-are-into-third-item.png"
import WhatWeAreIntoForthItemImage from "./what-we-are-into-forth-item.png"

const WhatWeAreInto = () => {
  const {
    TeamPageModel: { getTemplate },
  } = useStore()

  const sectionTitle = parse(
    getTemplate("about.whatWeAreInto.title", false) ||
      '<span class="text-red-300 line-through">CORE VALUES</span><br/>WHAT WE\'RE INTO',
  )

  const items = [
    {
      imageSrc: WhatWeAreIntoFirstItemImage.src,
      title:
        getTemplate("about.whatWeAreInto.items.1.title") || "You doing you",
      titleNode: parse(
        getTemplate("about.whatWeAreInto.items.1.title", false) ||
          "You doing you",
      ),
      descriptionNode: parse(
        getTemplate("about.whatWeAreInto.items.1.description", false) ||
          "This is your place to play and explore on your terms. Pure is here to help you discover what brings you pleasure in a safe, non-judgmental space.",
      ),
      className: "items-end tablet:items-start text-right tablet:text-left",
      imageClassName: "",
      titleClassName: "rotate-[-3deg]",
      descriptionClassName: "rotate-[-3deg]",
    },
    {
      imageSrc: WhatWeAreIntoSecondItemImage.src,
      title:
        getTemplate("about.whatWeAreInto.items.2.title") ||
        "Keeping it fun and light",
      titleNode: parse(
        getTemplate("about.whatWeAreInto.items.2.title", false) ||
          "Keeping it fun and light",
      ),
      descriptionNode: parse(
        getTemplate("about.whatWeAreInto.items.2.description", false) ||
          "We’re all about bringing joy and a sense of play to dating and intimacy. The best connections happen when you’re having a good time, right?",
      ),
      className: "items-start",
      imageClassName: "",
      titleClassName: "rotate-[2deg]",
      descriptionClassName: "",
    },
    {
      imageSrc: WhatWeAreIntoThirdItemImage.src,
      title:
        getTemplate("about.whatWeAreInto.items.3.title") ||
        "Open-minded community",
      titleNode: parse(
        getTemplate("about.whatWeAreInto.items.3.title", false) ||
          "Open-minded community",
      ),
      descriptionNode: parse(
        getTemplate("about.whatWeAreInto.items.3.description", false) ||
          "Every orientation, identity, and relationship style has a home here. Pure is an inclusive space for curious people to connect and celebrate the full spectrum of desire.",
      ),
      className: "items-end tablet:items-start",
      imageClassName: "",
      titleClassName: "rotate-[-3deg]",
      descriptionClassName: "rotate-[-3deg]",
    },
    {
      imageSrc: WhatWeAreIntoForthItemImage.src,
      title:
        getTemplate("about.whatWeAreInto.items.4.title") ||
        "Honesty and consent",
      titleNode: parse(
        getTemplate("about.whatWeAreInto.items.4.title", false) ||
          "Honesty and consent",
      ),
      descriptionNode: parse(
        getTemplate("about.whatWeAreInto.items.4.description", false) ||
          "Best connections start with being real. Being clear about what you’re into isn’t just fair, it leads to deeper and better chemistry. And consent? It’s everything. It’s the foundation that makes all the fun and exploration possible.",
      ),
      className: "items-end",
      imageClassName: "",
      titleClassName: "rotate-[4deg] tablet:rotate-[2deg]",
      descriptionClassName: "rotate-[4deg] tablet:rotate-0",
    },
  ]

  return (
    <section className="relative w-full">
      <div className="mx-auto max-w-screen-desktop-l px-[38px]">
        {/* First Row */}
        <div className="flex flex-col justify-center mb-[50px] tablet:mb-0  gap-[50px] desktop:gap-[150px] tablet:flex-row">
          <div className="w-fit tablet-s:min-w-[400px] tablet:min-w-[400px] laptop:max-w-[50%] h-fit laptop:pl-[0px] rotate-[3deg] font-pure text-[36px] leading-[48px] tablet:leading-[64px] tablet:text-[64px] mb-[24px] tablet:mb-0">
            {sectionTitle}
          </div>
          <div className="h-fit relative top-0 tablet:top-[-30px] flex flex-col items-end tablet:items-start">
            <img
              src={items[0].imageSrc}
              alt={items[0].title}
              className="relative mb-[25px] w-auto h-[190px] tablet:h-[336px] max-w-none"
            />
            <div className="w-fit laptop:w-[400px]">
              <h3 className="rotate-[-3deg] mb-4 ml-0 laptop:ml-[-8px] font-sans-bold text-[14px] tablet:text-[24px] leading-[18px] tablet:leading-[32px] whitespace-nowrap tracking-[0.1em]">
                {items[0].titleNode}
              </h3>
              <p className="rotate-[-3deg] font-sans text-[16px] tablet:text-[20px] leading-[20px] tablet:leading-[32px]">
                {items[0].descriptionNode}
              </p>
            </div>
          </div>
        </div>

        {/* Second Row */}
        <div className="mb-[50px] tablet:mb-0 flex flex-col justify-center gap-[50px] tablet-lg:gap-[100px] desktop:gap-[150px] tablet:flex-row">
          <div className="h-fit relative top-0 tablet:top-[-230px] flex flex-col items-start">
            <img
              src={items[1].imageSrc}
              alt={items[1].title}
              className="relative mb-[25px] h-[190px] tablet:h-[336px] max-w-none"
            />
            <div className="w-full laptop:w-[470px]">
              <h3 className="rotate-[2deg] mb-4 font-sans-bold text-[14px] tablet:text-[24px] leading-[18px] tablet:leading-[32px] whitespace-nowrap tracking-[0.1em]">
                {items[1].titleNode}
              </h3>
              <p className="font-sans text-[16px] tablet:text-[20px] leading-[20px] tablet:leading-[32px]">
                {items[1].descriptionNode}
              </p>
            </div>
          </div>

          <div className="h-fit relative top-0 tablet:top-[100px] flex flex-col items-end tablet:items-start">
            <img
              src={items[2].imageSrc}
              className="relative mb-[25px] h-[190px] tablet:h-[336px] max-w-none"
              alt={items[2].title}
            />
            <div className="w-full laptop:w-[450px]">
              <h3 className="rotate-[-3deg] mb-4 font-sans-bold text-[14px] tablet:text-[24px] leading-[18px] tablet:leading-[32px] whitespace-nowrap tracking-[0.1em]">
                {items[2].titleNode}
              </h3>
              <p className="rotate-[-3deg] font-sans text-[16px] tablet:text-[20px] leading-[20px] tablet:leading-[32px]">
                {items[2].descriptionNode}
              </p>
            </div>
          </div>
        </div>

        {/* Third Row */}
        <div className="grid grid-cols-1 tablet:grid-cols-2 place-items-end">
          <div className="h-fit relative top-0 tablet:top-[-100px] right-0 desktop:right-[40px]">
            <img
              className="relative mb-[25px] h-[190px] tablet:h-[336px] max-w-none"
              src={items[3].imageSrc}
              alt={items[3].title}
            />
            <div className="w-full laptop:w-[500px]">
              <h3 className="rotate-[4deg] tablet:rotate-[2deg] mb-4 font-sans-bold text-[14px] tablet:text-[24px] leading-[18px] tablet:leading-[32px] whitespace-nowrap tracking-[0.1em]">
                {items[3].titleNode}
              </h3>
              <p className="rotate-[4deg] tablet:rotate-0 font-sans text-[16px] tablet:text-[20px] leading-[20px] tablet:leading-[32px]">
                {items[3].descriptionNode}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

const WhatWeAreIntoComponent = observer(WhatWeAreInto)

export { WhatWeAreIntoComponent }
